/**
 * Static class to handle server-side errors
 */
export default class ErrorManager {
  /**
   * Main method to handle error objects
   * @param error {Object} request error from axios
   */
  static handleError(error) {
    // TODO: EVESSIO-9232 - extend server side error handling
    if (error.response.status === 400) {
      const firstFieldErrorMessage = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
      window.notificationManager.error(firstFieldErrorMessage);
    }
  }
}
